export default __webpack_public_path__ + "static/media/pp.1a29343a.jpg";